
import { AssessmentQuestion } from '@/types/assessment';
import { questionData as questions } from '../../data/questions';

/**
 * Gets all assessment questions
 */
export const getQuestions = (): AssessmentQuestion[] => {
  return questions;
};
